import { QDirRFCJSON } from "./QDirRFCJSON";
import { QPictureMgr } from "./QPictureMgr";
import { Globals } from "./Globals";
import { kConnectorRefreshDisabled, kEnumToLangCode } from "../constants";

export class QSvrChartMgr {
  constructor() {
    this.fTargetBoxID = null;
    this.fTargetBoxString = null;

    this.fTargetSCID = -1;

    this.fActiveFilters = null;
    this.fActiveHighlights = null;
    this.fActiveIH = null;

    this.fHeader = null;
    this.fPubMaster = null;

    this.fNumChainLevels = 0;

    this.fBuilderInfo = {};

    this.fChartID = null;

    this.fCheckpoints = null;
    this.fTotalBoxCount = null;

    this.fLocaleInfo = null;
    this.fTreeID = null;
  }

  //Where the heck should this live?
  IsConnectorRefreshable(connector) {
    var isRefreshable = true;
    if (connector == null) return false;

    var source = connector["source"];

    if (kConnectorRefreshDisabled.includes(source)) return false;

    switch (source) {
      case "UKG Ready":
        isRefreshable = !(connector["ukgDetailed"] === true);
        break;
      case "Thrive TRM":
        isRefreshable = false;
        break;
    }

    return isRefreshable;
  }

  //Move to chart metadata class.
  IsRefreshable(curChart) {
    var canManualRefresh = true;
    var chartmgr = this;
    var curImportInfo = curChart == null ? this.GetImportInfo() : curChart;
    if (curImportInfo == null) return false;

    var sectionKeys = ["import", "append", "merge"];
    for (var aSection in sectionKeys) {
      var key = sectionKeys[aSection];
      var data = curImportInfo[key];
      if (data == null) continue;

      if (Array.isArray(data))
        data.forEach(function (item) {
          if (!chartmgr.IsConnectorRefreshable(item)) {
            canManualRefresh = false;
          }
        });
      else canManualRefresh = chartmgr.IsConnectorRefreshable(data);

      if (!canManualRefresh) return false;
    }
    return canManualRefresh;
  }

  GetTargetSCID() {
    return this.fTargetSCID;
  }

  SetTargetSCID(scID) {
    this.fTargetSCID = scID;
  }

  SetTargetBoxID(targetBoxID) {
    this.fTargetBoxID = targetBoxID;
  }

  GetTargetBoxID() {
    return this.fTargetBoxID;
  }

  SetTargetBoxIsAux(isAux) {
    this.fTargetBoxIsAux = isAux;
  }

  GetCurrentChartData(metadata, chartID) {
    var curChart = null;
    if (!metadata["charts"]) return curChart;

    if (chartID == null) chartID = this.GetChartID();

    for (var aChart in metadata["charts"]) {
      if (metadata["charts"][aChart]["ID"] === chartID) {
        curChart = metadata["charts"][aChart];
        break;
      }
    }
    return curChart;
  }

  GetCurrentChartID(metadata, chartID) {
    for (var aChart in metadata["charts"]) {
      if (metadata["charts"][aChart]["ID"] === chartID) return aChart;
    }
  }

  // Accepts the new localizationConfig format produced by LocalizationCard:
  //   { supportedLanguages: number[], fields: { "Box-FieldName": { name, type, languages: { [enumLanguage]: "MappedFieldName" } } } }
  // Converts it to the internal fLocaleInfo structure keyed by class name:
  //   { "Box": { "FieldName": { "en": "MappedFieldName" } }, "Position": { ... } }
  // A position field can only be localized by another position field, and likewise
  // for holder (Box) fields — the type is enforced at the UI level via onlyFromType.
  SetLocaleInfo(localizationConfig) {
    if (!localizationConfig?.fields) {
      this.fLocaleInfo = null;
      return;
    }

    const parsed = {};
    for (const [key, fieldConfig] of Object.entries(localizationConfig.fields)) {
      const dashIdx = key.indexOf("-");
      if (dashIdx < 0) continue;
      const className = key.substring(0, dashIdx);
      const fieldName = fieldConfig.name;

      const langMap = {};
      for (const [langEnum, localizedName] of Object.entries(fieldConfig.languages ?? {})) {
        const langCode = kEnumToLangCode[langEnum];
        if (langCode && typeof localizedName === "string" && localizedName.trim() !== "")
          langMap[langCode] = localizedName;
      }

      if (Object.keys(langMap).length === 0) continue;

      if (!parsed[className]) parsed[className] = {};
      parsed[className][fieldName] = langMap;
    }

    this.fLocaleInfo = parsed;
  }

  Localize(className, value, localizationExists) {
    var curLangCode = Globals._stringMgr.fCurLangStr;
    var localizationBoolean =
      localizationExists != null ? localizationExists : this.LocalizationExists(className, value);
    return localizationBoolean ? this.fLocaleInfo[className][value][curLangCode] : value;
  }

  LocalizationExists(className, value) {
    var curLangCode = Globals._stringMgr.fCurLangStr;
    return (
      this.fLocaleInfo != null &&
      this.fLocaleInfo[className] != null &&
      this.fLocaleInfo[className][value] != null &&
      this.fLocaleInfo[className][value][curLangCode] != null
    );
  }

  GetThisChartInfo() {
    var chartInfo = Globals._wsMgr.fOrgInfo.GetMasterChartList();
    for (var achart in chartInfo) {
      if (chartInfo[achart]["chartID"] == this.GetChartID()) return chartInfo[achart];
    }
    return null;
  }

  CallDirRFC(callbackObj, mode, type) {
    var org = Globals._wsMgr.GetAccountName();
    var user = Globals._wsMgr.GetUserName();
    var dirRFC = new QDirRFCJSON();
    dirRFC.InitDirRFC(callbackObj, type);
    dirRFC.SetParams(org, user, mode);
    Globals._rfcMgr.QueueRFC(dirRFC);
  }

  SetCheckPoints(checkpoints) {
    this.fCheckpoints = checkpoints;
  }

  GetPictureMgr() {
    if (!this.fPictureMgr) {
      this.fPictureMgr = new QPictureMgr();
      this.fPictureMgr.InitPictureMgr(Globals._wsMgr, null);
    }
    return this.fPictureMgr;
  }

  SavePrevValue(key, value) {
    Globals._svrChartMgr.fBuilderInfo[key] = value;
  }

  GetPrevValue(key, defaultValue) {
    var value = Globals._svrChartMgr.fBuilderInfo[key];
    if (value == null) value = defaultValue;
    return value;
  }

  GetChartIndexByID(curChartID) {
    var chartList = Globals._wsMgr.fOrgInfo.GetMasterChartList();
    var curChartIdx = 0;
    for (var aChart in chartList) {
      if (chartList[aChart]["chartID"] == curChartID) {
        curChartIdx = aChart;
        break;
      }
    }
    return curChartIdx;
  }

  GetMasterChartByID(curChartID) {
    var chartList = Globals._wsMgr.fOrgInfo.GetMasterChartList();
    var chartIndex = this.GetChartIndexByID(curChartID);
    return chartList[chartIndex];
  }

  PersistFH(theDoc, skipInteractive) {
    var activeFilters = {};
    var activeHighlights = {};
    if (theDoc) {
      var theHighlightMgr = theDoc.GetHighlightMgr();
      if (theHighlightMgr) {
        var highlights = theHighlightMgr.GetAllowedHighlightList();
        for (var highIdx in highlights) {
          var curHighlight = highlights[highIdx];
          if (curHighlight.fActive) activeHighlights[curHighlight.fName] = true;
        }
        if (theHighlightMgr.HasActiveIH() && !skipInteractive)
          this.fActiveIH = theHighlightMgr.GetInteractiveHighlights();
      }

      var theFilterMgr = theDoc.GetFilterMgr();
      if (theFilterMgr) {
        var filters = theFilterMgr.GetAllowedFilterList();
        for (var filtIdx in filters) {
          var curFilter = filters[filtIdx];
          if (!curFilter.fFilterOff) activeFilters[curFilter.fFilterName] = true;
        }
      }
    }
    this.fActiveFilters = activeFilters;
    this.fActiveHighlights = activeHighlights;
  }

  SetImportInfo(importInfo) {
    //Data minimization. There are passwords and sensitive info in the import block that are preferably not passed around the frontend.
    this.fImportInfo = {
      allowRefresh: importInfo["allowRefresh"],
      import: importInfo["import"],
      append: importInfo["append"],
      merge: importInfo["merge"]
    };
  }

  GetImportInfo() {
    return this.fImportInfo;
  }

  SetStaticFormulaInfo(formulaInfo) {
    this.fStaticFormulaInfo = formulaInfo;
  }

  GetStaticFormulaInfo() {
    return this.fStaticFormulaInfo;
  }

  SetLastPlanID(planID) {
    this.fLastPlanID = planID;
  }

  GetLastPlanID() {
    return this.fLastPlanID;
  }

  SetLastReportID(reportID) {
    this.fLastReportID = reportID;
  }

  GetLastReportID(reportID) {
    return this.fLastReportID;
  }

  BuildCBSettings(builderInfo) {
    var settings = {};

    settings["levels"] = builderInfo.levels;
    settings["ctemplate"] = builderInfo.ctemplate;
    settings["autoFormat"] = builderInfo.autoFormat;
    settings["mtemplate"] = builderInfo.mtemplate;
    settings["page"] = builderInfo.page;
    settings["isAux"] = builderInfo.isAux;
    settings["liveChart"] = builderInfo.liveChart === true;
    var type = "builder";
    if (builderInfo.fBuildArchive === true) type = "Archive";
    settings["type"] = type;
    var validFilterValue = false;
    if (builderInfo.importFilterValue) validFilterValue = true;
    else if (
      builderInfo.importFilterLogic === "isempty" ||
      builderInfo.importFilterLogic === "isnotempty"
    )
      validFilterValue = true;
    if (
      (builderInfo.doImportFilter && builderInfo.importFilterField && validFilterValue) ||
      builderInfo.doImportFilterComplex
    ) {
      var theImportFilter = {};
      if (!builderInfo.doImportFilterComplex) {
        var comparisionType = builderInfo.importFilterLogic;
        if (!comparisionType) comparisionType = "equals";
        if (comparisionType === "inlist" || comparisionType === "notinlist") {
          builderInfo.importFilterValue = builderInfo.importFilterValue.join();
        }
        theImportFilter["field"] = builderInfo.importFilterField;
        theImportFilter["value"] = builderInfo.importFilterValue;
        theImportFilter["comparison"] = comparisionType;
      } else {
        theImportFilter["isComplex"] = true;
        theImportFilter["complexDef"] = builderInfo.importFilterComplexRule;
      }

      theImportFilter["doFilteredMgrs"] = builderInfo.doImportFilteredMgrs === true;
      theImportFilter["doCOC"] = builderInfo.doImportFilterCOC === true;
      theImportFilter["filterMatch"] = builderInfo.importFilterMatch;
      settings["importFilter"] = theImportFilter;
    }

    if (builderInfo.doSupportingFunctionChart) {
      settings["doSupportingFunctionChart"] = true;
      settings["supportingFunctionField"] = builderInfo.supportingFunctionField;
      settings["supportedFunctionField"] = builderInfo.supportedFunctionField;
    }

    if (builderInfo.doCoHeads)
      //toggle is on. let's go girls.
      settings["coheads"] = builderInfo.coHeadList; //Should this be a string? Or let backend do it?

    if (builderInfo.doPlaceholder) {
      var placeHolders = {};
      placeHolders["doPlaceHolder"] = true;
      if (builderInfo.placeHolderFunction)
        placeHolders["placeHolderFunction"] = builderInfo.placeHolderFunction;

      if (builderInfo.placeHolderSupFunction)
        placeHolders["placeHolderSupFunction"] = builderInfo.placeHolderSupFunction;

      settings["placeHolders"] = placeHolders;
    }

    if (builderInfo.doMultiChart) {
      var multiChartInfo = {};
      multiChartInfo["doMultiChart"] = true;
      if (builderInfo.multiChartSplitOn)
        multiChartInfo["multiChartSplitOn"] = builderInfo.multiChartSplitOn;

      if (builderInfo.multiChartAltSplitOn)
        multiChartInfo["multiChartAltSplitOn"] = builderInfo.multiChartAltSplitOn;

      settings["multiChartInfo"] = multiChartInfo;
    }

    if (builderInfo.sort) settings["sort"] = builderInfo.sort;

    if (builderInfo.doRestrictQuery) settings["doRestrictQuery"] = builderInfo.doRestrictQuery;

    if (builderInfo.doRestrictQuery && builderInfo.restrictQuery)
      settings["restrictQuery"] = builderInfo.restrictQuery;

    //CHAIN OF COMMAND
    if (builderInfo.doChain) settings["includeChain"] = builderInfo.chainlevels;

    //ORPHANS
    if (builderInfo.doOrphans) settings["includeOrphans"] = builderInfo.doOrphans;

    // defer to docType here
    //if (builderInfo.fBuildArchive)
    //settings['buildArchive'] = true;

    //DATA FILTER
    if (builderInfo.importFilterLogic == "isempty" || builderInfo.importFilterLogic == "isnotempty")
      builderInfo.importFilterValue = true;

    if (builderInfo.breaks) settings["subchartrule"] = builderInfo.breaks;

    if (builderInfo.scSort) settings["scSort"] = builderInfo.scSort;

    return settings;
  }

  SetNumChainLevels(numLevels) {
    this.fNumChainLevels = numLevels;
  }

  GetNumChainLevels() {
    return this.fNumChainLevels;
  }
}
